import { createScope, createService } from '@tencent/tiny-ioc';
import { SlideDataServices } from '../../../core/slide-data-services.core';
import type { IOnlineEditService } from './interfaces/online-edit-service.interface';
import type { IOnlineEditDataFetcher } from './interfaces/online-edit-data-fetcher.interface';
import type { ICooperationLockManager } from './interfaces/cooperation-lock-manager.interface';
import type { IUserManager } from './interfaces/user-manager.interface';
import type { ICollaboratorUserManager } from './interfaces/collaborator-user-manager.interface';
import type { ICursorManager } from './interfaces/cursor-manager.interface';
import type { IOnlineApiService } from './interfaces/online-api-service.interface';
import { ICollaborationManager } from '@tencent/slide-sdk-model/src/manager/collaboration-manager';
import { IOTTransform } from '@tencent/slide-sdk-ot-transform';

export const OnlineEditServices = createScope(() => {
    const OnlineApiService = createService<IOnlineApiService>().dependsOn([SlideDataServices.Infra.Logger]);

    // 在线编辑数据拉取
    const OnlineEditDataFetcher = createService<IOnlineEditDataFetcher>().dependsOn([
        SlideDataServices.ClientVarsService,
        OnlineApiService,
        SlideDataServices.Infra.Logger,
    ]);

    // 在线编辑服务
    const OnlineEditService = createService<IOnlineEditService>().dependsOn([
        SlideDataServices.Infra.Logger,
        OnlineEditDataFetcher,
        SlideDataServices.EventManager,
    ]);

    const UserManager = createService<IUserManager>().dependsOn([
        SlideDataServices.ClientVarsService,
        OnlineApiService,
        SlideDataServices.SDKDataServices.EventManager,
    ]);

    const OTTransformManager = createService<IOTTransform>().dependsOn([
        SlideDataServices.Infra.Logger,
        SlideDataServices.SDKDataServices.EventManager,
        SlideDataServices.DocInfoManager,
    ]);

    const CollaborationManager = createService<ICollaborationManager>().dependsOn([
        SlideDataServices.SDKDataServices.PresentationStoreService,
        SlideDataServices.ClientVarsService,
        SlideDataServices.ContentStatusManager,
        OTTransformManager,
        SlideDataServices.SDKDataServices.EventManager,
        SlideDataServices.Infra.Logger,
        SlideDataServices.PrivilegeManager,
    ]);

    const CooperationLockManager = createService<ICooperationLockManager>().dependsOn([
        SlideDataServices.ClientVarsService,
        SlideDataServices.SDKDataServices.PresentationStoreService,
        UserManager,
        CollaborationManager,
        SlideDataServices.EventManager,
        SlideDataServices.SDKDataServices.EventManager,
        SlideDataServices.Infra.Logger,
    ]);

    const CollaboratorUserManager = createService<ICollaboratorUserManager>().dependsOn([
        SlideDataServices.SDKDataServices.EventManager,
    ]);

    const CursorManager = createService<ICursorManager>().dependsOn([
        SlideDataServices.ClientVarsService,
        UserManager,
        SlideDataServices.EventManager,
        SlideDataServices.SDKDataServices.EventManager,
        SlideDataServices.Infra.Logger,
    ]);

    const OnlineEditNoticeManager = createService<{}>().dependsOn([
        SlideDataServices.Infra.Logger,
        SlideDataServices.SDKDataServices.EventManager,
        SlideDataServices.EventManager,
        SlideDataServices.ContentStatusManager,
    ]);

    // 在线文档编辑数据上报器
    const OnlineEditReporter = createService<{}>().dependsOn([
        SlideDataServices.Infra.Logger,
        SlideDataServices.ClientVarsService,
        SlideDataServices.States.SlideCountState,
        SlideDataServices.EventManager,
    ]);

    return {
        OnlineEditDataFetcher,
        OnlineEditService,
        OnlineApiService,
        UserManager,
        CollaborationManager,
        CooperationLockManager,
        CollaboratorUserManager,
        CursorManager,
        OnlineEditNoticeManager,
        OTTransformManager,
        OnlineEditReporter,
    };
});
